/**
 * DOCTRACK part 4 (C8) - `?doc=<filing id>` opens one document's comparison, on the deal page and on the Property
 * Database record page. The one copy of the rule: the value is always a `document_filings.id` (UUID-shaped), never a
 * file link id - parts 5, 6 and 7 link with it.
 * ⛔ Derived from the address with no state and no reset effect: the pages' `[id]` effects run on mount and would drop
 *   the link, and another record is a new address without `?doc`. Every other parameter stays.
 */
import { useSearchParams } from 'react-router-dom';

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function useDocParam(): { docFilingId: string | null; openDoc: (filingId: string) => void; closeDoc: () => void } {
  const [searchParams, setSearchParams] = useSearchParams();
  const raw = searchParams.get('doc');
  const docFilingId = raw && UUID.test(raw) ? raw : null;
  const openDoc = (filingId: string) => {
    const next = new URLSearchParams(searchParams);
    next.set('doc', filingId);
    setSearchParams(next, { replace: true });
  };
  const closeDoc = () => {
    const next = new URLSearchParams(searchParams);
    next.delete('doc');
    setSearchParams(next, { replace: true });
  };
  return { docFilingId, openDoc, closeDoc };
}
